<template>
    <div id="listings_wrapper">
         <div>
            <div class="pt-8 d-flex">
                <div class="sansation info--text d-inline px-4"><h2>Listings</h2></div>
            </div>

            <div class="pt-0 pb-4 px-4" flat>
                <div class="d-flex d-block justify-space-between align-center">                
                    <div class="d-inline mb-7" style="width: 40%">
                        <v-text-field 
                            label="Search" 
                            color="white" 
                            single-line 
                            hide-details 
                            v-model="search" 
                            append-icon="mdi-magnify">
                        </v-text-field>
                    </div>

                    <div class="d-inline d-flex mb-7" style="width: 40%">
                        <v-autocomplete 
                            v-model="listing_status"
                            :items="listing_statuses" 
                            label="Status" 
                            hide-details 
                            multiple 
                            class="d-inline mt-2 mx-3"
                            color="primary darken-1"
                            @change="filterListingsByStatus()">
                        </v-autocomplete>
                    </div>
                    
                    <div class="d-inline mb-7">
                        <v-btn 
                            color="primary darken-1 white--text" 
                            dark
                            @click="editListing({})">
                            Create New Listing
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>

        <v-data-table
            :headers="listing_headers"
            :items="filteredListings"
            :items-per-page="-1"
            :search="search"
            :loading="table_loading"
            loading-text="Pulling listings ..."
            sort-by="post_date"
            fixed-header
            :height="'calc(100vh - 280px)'"
            @click:row="editListing">

            <!-- <template v-slot:top>
                <div class=" pt-0 pb-4 px-4" flat>
                    <div class="d-flex d-block justify-space-between align-center">
                    
                        <div class="d-inline mb-7" style="width: 40%">
                            <v-text-field 
                                label="Search" 
                                color="white" 
                                single-line 
                                hide-details 
                                v-model="search" 
                                append-icon="mdi-magnify">
                            </v-text-field>
                        </div>

                        <div class="d-inline d-flex mb-7" style="width: 40%">
                            <v-checkbox 
                                v-for="filter in listing_statuses"
                                :key="filter.value"
                                :input-value="listing_status.includes(filter.value)" 
                                :label="filter.text" 
                                hide-details 
                                class="d-inline mt-2 mx-3" 
                                color="primary darken-1"
                                @change="filterListingsByStatus(filter.value, $event)">
                            </v-checkbox>
                        </div>
                        
                        <div class="d-inline mb-7">
                            <v-btn 
                                color="primary darken-1 white--text" 
                                dark
                                @click="editListing({})">
                                Create New Listing
                            </v-btn>
                        </div>
                    </div>
                </div>
            </template> -->

            <template v-slot:no-data>
                <div class="text-center pt-12">
                    <v-icon large>mdi-alert-circle</v-icon>
                    <p class="mt-2">No listings found matching your filters.</p>
                </div>
            </template>

            <template v-slot:[`item.listing_id`]="{ item }">
                <td @click.stop="openDetailsNewTab($event, item)">
                    <div class="d-flex justify-space-between">
                        {{ item.listing_id }}
                        <v-icon 
                            right 
                            x-small
                            class="pewter--text text--darken-1">
                            mdi-open-in-new
                        </v-icon>
                    </div>
                </td>
            </template>

            <template v-slot:[`item.buyer_count`]="{ item }">
                <td @click.stop="openBuyersNewTab($event, item)" class="d-flex justify-end">
                    <div class="align-center">
                        {{ item.buyer_ratio }} 
                        <v-badge v-if="parseInt(item.touch_buyers)" color="error" inline :content="item.touch_buyers"></v-badge>
                        <v-icon 
                            right 
                            x-small
                            class="pewter--text text--darken-1">
                            mdi-open-in-new
                        </v-icon>
                    </div>
                </td>
            </template>

            <template v-slot:[`item.accepting`]="{ item }">
                <div class="text-end">{{ item.accepting }}</div>
            </template>

            <template v-slot:[`item.aum`]="{ item }">
                <div lass="text-end" v-html="item.aum_value"></div>
            </template>

            <template v-slot:[`item.broker_dealers`]="{ item }">
                <div class="text-end" v-html="item.broker_dealers"></div>
            </template>

            <template v-slot:[`item.custodians`]="{ item }">
                <div class="text-end" v-html="item.custodians"></div>
            </template>

            <template v-slot:[`item.tamps`]="{ item }">
                <div class="text-end" v-html="item.tamps"></div>
            </template>

            <template v-slot:[`item.type_name`]="{ item }">
                <div class="text-end" v-html="item.type_name"></div>
            </template>

            <template v-slot:[`item.post_date`]="{ item }">
                <div class="text-end">{{ item.post_date }}</div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <td @click.stop class="text-end">
                    <v-select 
                        v-model="item.status"
                        :items="listing_statuses"
                        dense
                        hide-details
                        class="status_dropdown"
                        @change="changeStatus(item)">
                    </v-select>
                </td>
            </template>

            <template v-slot:[`item.is_active`]="{ item }">
                <div class="text-end">{{ item.is_active ? "Yes" : "No" }}</div>
                <!-- <td @click.stop class="pa-0 ma-0">
                    <div class="d-flex justify-end">
                        <v-switch 
                            :input-value="item.is_active"
                            color="success darken-2" 
                            hide-details 
                            inset
                            class="mt-n1"
                            @change="listingActive(item, $event)">
                        </v-switch>
                    </div>
                </td> -->
            </template>
        </v-data-table>
    </div>
</template>


<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
    import { formatBigInt } from '../helpers/utilities'

    export default {
        name: 'Listings',

        data: () => ({
            table_loading: false,
            listings: [],
            search: '',
            listing_status: [1,2],
            filteredListings: [],
            listing_headers: [
                { text: 'Identifier',   value: 'listing_id',     align: 'start', width: '',    sortable: true },
                { text: 'Buyers',       value: 'buyer_count',    align: 'end',   width: '',    sortable: true },
                { text: 'Accepting',    value: 'accepting',      align: 'end',   width: '',    sortable: true },
                { text: 'AUM',          value: 'aum',            align: 'end',   width: '',    sortable: true },
                { text: 'BDs',          value: 'broker_dealers', align: 'end',   width: '12%', sortable: true },
                { text: 'Custodians',   value: 'custodians',     align: 'end',   width: '12%', sortable: true },
                { text: 'Tamps',        value: 'tamps',          align: 'end',   width: '12%', sortable: true },
                { text: 'Type',         value: 'type_name',      align: 'end',   width: '',    sortable: true },                
                { text: 'Post Date',    value: 'post_date',      align: 'end',   width: '',    sortable: true },
                { text: 'Status',       value: 'status',         align: 'end',   width: '10%', sortable: false },                
                { text: 'Active',       value: 'is_active',      align: 'end',   width: '',    sortable: false }
            ],
            listing_statuses: [],
            listing_types: [],
            listing_stages: [],
            new_tab_menu: false
        }),

        watch: {
            dialog (val) {
                val || this.close();
            },
            listings () {
                setTimeout(() => {
                    this.filterListingsByStatus();
                }, 1000);
            }
        },
        
        created () {
            document.title = `Listings`;
            this.getLists();
        },
        
        mounted () {
            this.table_loading = true
            this.getListings();
        },
        
        methods: {
            openDetailsNewTab: function ( e, item ) {
                // e.preventDefault()
                let route = this.$router.resolve({ path: `/listing_details/${item.id}`});
                window.open(route.href, '_blank');
            },

            openBuyersNewTab: async function (e, item ) {
                let route = this.$router.resolve({ path: `/listing_buyers/${item.id}`});
                window.open(route.href, '_blank');
            },
            
            getListings: async function () {
                try {
                    const get_listings = await axios.get(`${appUrls.api}/api/admin/listings`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    
                    if ( get_listings.data.outcome ){
                        const setupListingData = async () => {
                            this.listings = get_listings.data.listings;
                            let i = 0;
                            for( let listing of this.listings ) {
                                this.listings[i].post_date              = listing.post_date != null ? listing.post_date.substr(0, 10) : '';
                                this.listings[i].anticipated_close_date = listing.anticipated_close_date != null ? listing.anticipated_close_date.substr(0, 10) : '';
                                this.listings[i].revenue_t12_asof_date  = listing.revenue_t12_asof_date != null ? listing.revenue_t12_asof_date.substr(0, 10) : '';

                                this.listings[i].listing_type = this.listings[i].listing_type != null ? parseInt(this.listings[i].listing_type) : 0;
                                this.listings[i].status       = this.listings[i].status != null ? parseInt(this.listings[i].status) : 0;
                                this.listings[i].stage        = this.listings[i].stage != null ? parseInt(this.listings[i].stage) : 0;

                                // AUM
                                this.listings[i].aum_value = this.listings[i].aum != null ? formatBigInt(this.listings[i].aum) : '<span style="color:#F04881">Not Defined</span>';

                                // ACCEPTING APPLICATONS
                                this.listings[i].accepting = this.listings[i].accepting_flag ? 'Yes' : 'No'
                                
                                // BROKER DEALER
                                this.listings[i].broker_dealers = this.listings[i].company_broker_dealer != null ? this.listings[i].company_broker_dealer : '<span style="color:#F04881">Not Defined</span>'

                                // CUSTODIANS
                                this.listings[i].custodians = this.listings[i].company_custodians != null ? this.listings[i].company_custodians : '<span style="color:#F04881">Not Defined</span>'

                                // TAMPS
                                this.listings[i].tamps = this.listings[i].company_tamps != null ? this.listings[i].company_tamps : '<span style="color:#F04881">Not Defined</span>'
                                
                                // IMAGE
                                if (this.listings[i].custom_image != null ) {
                                    this.listings[i].image = require(`@/assets/listings/custom/${this.listings[i].custom_image}`);
                                } else {
                                    this.listings[i].image = require(`@/assets/listings/states/${this.listings[i].state}.jpg`);
                                }

                                // STATUS NAME
                                if ( this.listings[i].status != 0 ) {
                                    let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listings[i].status);
                                    this.listings[i].status_name = statusObj.text;
                                } else {
                                    this.listings[i].status_name = '<span style="color:#F04881">Not Defined</span>';
                                }

                                // STAGE NAME
                                if ( this.listings[i].stage != 0 ) {
                                    let stageObj = this.listing_stages.find(obj => parseInt(obj.value) === this.listings[i].stage);
                                    this.listings[i].stage_name = stageObj.text;
                                } else {
                                    this.listings[i].stage_name = '<span style="color:#F04881">Not Defined</span>';
                                }

                                // TYPE NAME
                                if ( this.listings[i].listing_type != 0 ) {
                                    let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listings[i].listing_type);
                                    this.listings[i].type_name = typeObj.text;
                                } else {
                                    this.listings[i].type_name = '<span style="color:#F04881">Not Defined</span>';
                                }

                                // BUYERS OF TOTAL BUYERS
                                if ( this.listings[i].total_buyers != 0 ) {
                                    this.listings[i].buyer_ratio = this.listings[i].buyer_count+' of '+this.listings[i].total_buyers;
                                } else {
                                    this.listings[i].buyer_ratio = 0;
                                }

                                i++;
                            }
                        }
                        await setupListingData()
                        this.table_loading = false
                    } else {
                        this.$feedback.error( 'There seems to be a problem pulling the listings. Run, tell Cliff!' );
                    }
                
                } catch ( error ) {
                    console.error('Error setting table loading state:', error);
                    this.$feedback.error( 'There seems to be a problem pulling the listings. Run, tell Cliff!' );
                }
            },

            filterListingsByStatus: async function () {
                try {
                    this.table_loading = true

                    // FILTERING MAGIC BASED ON STATUS
                    this.filteredListings = this.listings.filter(row => {
                        return this.listing_status.includes(parseInt(row.status)) === true;
                    });

                    this.table_loading = false 
                } catch ( error ) {
                    console.error('Error filtering listings by status:', error);
                }
            },

            listingActive (item, value) {
                const this_listing_value = value
                const this_listing = this.listings.indexOf(item);
                
                axios.put(`${appUrls.api}/api/admin/chg_listing_active`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    update: {
                        is_active: this_listing_value,
                        id: item.id,
                        listing_id: item.listing_id
                    }
                })
                .then( res => {
                    if ( res.data.outcome ) {
                        this.listings[this_listing].is_active = res.data.listing_is_active

                        this.$feedback.success( res.data.message, 3000 );
                    } else {
                        this.$feedback.error( res.data.message, 3000 );
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            changeStatus (item) {
                const this_listing = this.listings.indexOf(item);

                axios.put(`${appUrls.api}/api/admin/chg_listing_status`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    update: {
                        status: item.status,
                        id: item.id,
                        listing_id: item.listing_id
                    }
                })
                .then( res => {
                    if ( res.data.outcome ) {
                        this.listings[this_listing].status = res.data.listing_status

                        this.$feedback.success( res.data.message, 3000 );
                    } else {
                        this.$feedback.error( res.data.message, 3000 );
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            editListing (item) {
                this.$router.push({ path: `/listing_details/${item.id}`});
            },

            getLists: async function () {
                let optionsLists = [ 
                    {'name': 'listing_types', 'type': 'int'}, 
                    {'name': 'listing_stages', 'type': 'int'},
                    {'name': 'listing_statuses', 'type': 'int'},
                ];

                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    if(res.data.outcome){
                        let arrLists = res.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'listing_stages') this.listing_stages = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                            if (arrLists[l].name == 'listing_statuses') this.listing_statuses = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>

<style scoped>
    #listings_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 3rem 0 0 0;
        display: flex;
        flex-direction: column;
        height: 100vh; 
    }
    tr:nth-of-type(odd) {
        background-color: rgba(223, 233, 236, .25);
    }
 >>> tbody tr {
        cursor: pointer !important;
    }
    .status_dropdown {
        font-size: .9rem;
    }
    .status_dropdown >>> .v-input__slot::before {
        border-style: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Listings.vue